export default "__VITE_ASSET__spY6pyGt__"